import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionTitle, buildPlxData,
} from '../common/styles';

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 32.4vw;
    max-width: 466px;
  `)};
  align-items: start;
`;

const Image = styled(Img)`
  ${props => (props.theme.isMobile ? `
    width: calc(100vw - 40px);
    height: 100vw;
  ` : `
    width: 516px;
    height: 465px;
  `)};
  border-radius: 10px;
  object-fit: cover;
`;

const topPadding = 110;
const bottomPadding = 150;
const Container = styled.div`
  display: flex;
  align-items: center;
  ${props => (props.theme.isMobile ? `
    margin: 0;
    padding: 80px 20px;
    flex-direction: column;
    width: 100vw;
  ` : `
    margin: 0 auto;
    padding: ${topPadding + 8}px 0 ${bottomPadding + 8}px 0;
    max-width: 1090px;
    width: 75.7vw;
    justify-content: center;
  `)};

  &:after {
    order: 0;
    content: "";
    width: 7.5vw;
    ${props => (props.theme.isMobile ? `
      height: 42px;
    ` : `
      max-width: 108px;
    `)};
  }

  & > .text-container {
    order: -1;
  }

  & > .image-container {
    order: 1;
  }
`;

const Title = styled(SectionTitle)`
  margin: 0;
  margin-bottom: ${props => (props.theme.isMobile ? 34 : 18)}px;
  ${props => (props.theme.isMobile && `
    font-size: 35px;
    line-height: 46px;
  `)};
`;

const Desc = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 20px;
  line-height: 25px;

  & > p {
    margin: 15px 0;
  }
`;

export default function Story() {
  const { isMobile, ourStory } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#story', topPadding, bottomPadding);

  return (
    <Container id="story">
      <Plx className="text-container" parallaxData={plxData.text} disabled={isMobile}>
        <TextContainer>
          <Title>Our Story</Title>
          <Desc>
            <p>
              Tom McKay and James Marlay started Livewire from the kitchen of James’ 2 bedroom
              terrace in Inner Sydney back in 2013. They thought the world needed a social media
              platform for investors, so they built it and ran a “beta trial” with 128 users. One
              week later they only had 17 of those investors still engaging. It wasn’t very social!
            </p>
            <p>
              So they went back to the drawing board and called their former users to ask “why did
              you leave and what would bring you back?” Everyone wanted less noise and more signal
              - genuine experts sharing their ideas. So Livewire became a platform for Australia’s
              leading investment professionals to share their insights and a unique place for
              investors to stay informed about markets.
            </p>
            <p>
              The website has grown to reach millions of investors a year and is one of the most
              engaged investor websites in the country.
            </p>
          </Desc>
        </TextContainer>
      </Plx>
      <Plx className="image-container" parallaxData={plxData.image} disabled={isMobile}>
        <Image src={ourStory} />
      </Plx>
    </Container>
  );
}
